import{htmlToText}from"html-to-text";export default function htmlInnerText(){return this.transform((a,b)=>htmlToText(b,{preserveNewlines:!1}).trim())}